import React from 'react';
import {Form} from "../lib/Form";

//TODO Validation & error handling
//TODO set keyboard

export default function DownloadForm({
        headerText='Download details',
        submitText='Download',
        ...props
    }){
    const company = props.company || {};

    const fields = [
        {
            id: 'notes',
            decorator: {
                rules: [{
                    max: 500,
                    message: 'text too long'
                }],
                initialValue: company.state,
            },
            label: 'Notes',
            type: 'TextareaItem',  //TODO ? pass componemt type  - clone?
            rows: 0
        }
    ];

    return (
        <Form
            fields={fields}
            headerText={headerText}
            submitText={submitText}
            labelNumber={3}
            {...props} />
    );
}